module.exports = __webpack_public_path__ + "img/y- (7).84256c1d.png";